import React from 'react';
import { Link } from 'react-router-dom';
import { APP_CONFIG } from '../../constants';

export type PodCrumb = { label: string; to?: string };

/**
 * The one breadcrumb used on every AI Pod and subscription screen:
 * "<Pods tab> / Pod name / …". The first crumb always returns to the pods marketplace.
 */
const PodBreadcrumb: React.FC<{ items: PodCrumb[]; className?: string }> = ({ items, className }) => {
  const crumbs: PodCrumb[] = [{ label: APP_CONFIG.PODS_TAB_LABEL, to: '/agent-types?tab=pods' }, ...items];
  return (
    <nav aria-label="Breadcrumb" className={`mb-8 flex flex-wrap items-center gap-2 text-sm ${className ?? ''}`}>
      {crumbs.map((crumb, i) => {
        const last = i === crumbs.length - 1;
        return (
          <React.Fragment key={`${crumb.label}-${i}`}>
            {i > 0 && <span className="text-agentic-gray-300">/</span>}
            {crumb.to && !last ? (
              <Link to={crumb.to} className="flex items-center gap-1 font-medium text-agentic-primary-blue hover:underline">
                {i === 0 && (
                  <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                  </svg>
                )}
                {crumb.label}
              </Link>
            ) : (
              <span className={last ? 'text-agentic-text-secondary' : 'text-agentic-text-muted'} aria-current={last ? 'page' : undefined}>
                {crumb.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default PodBreadcrumb;
